module.exports = __webpack_public_path__ + "account_circle-v1-1b0715fb.svg";